import {
  AccessApprovalsFlowsDocument,
  ApprovalsValueObjectsApprovalCategoryEnum,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useAccessApprovalFlows = (
  category?: ApprovalsValueObjectsApprovalCategoryEnum,
  accessId?: string
) => {
  const { data, loading } = useQuery(AccessApprovalsFlowsDocument, {
    variables: { category: category, accessId: accessId ?? '1' },
    fetchPolicy: 'network-only',
    skip: !accessId,
  })

  const approvalFlows =
    data?.approvals.accessApprovalFlowsConnection.edges?.map((edge) => edge.node) ?? []

  return {
    loading,
    approvalFlows,
  }
}
